import { diyLoanCreditMobileErrorViewed, diyLoanCreditReportViewed } from "./tracking";

export const QUESTION_TYPES = {
    RADIO: "radio",
    INPUT: "input"
};

export const QUESTION_KEYS = {
    OWNERSHIP: "ownershipType",
    LOAN: "loanStatus",
    CIBIL: "cibil",
    CONSENT: "consent"
};

export const QUESTION_LIST = [
    {
        title: "What is your car ownership type?",
        type: QUESTION_TYPES.RADIO,
        key: QUESTION_KEYS.OWNERSHIP,
        options: [
            {
                displayText: "Individually-owned Car",
                key: "INDIVIDUAL"
            },
            {
                displayText: "Company-owned Car",
                key: "COMPANY"
            }
        ],
        ctaLabel: "CONFIRM"
    },
    {
        title: "What is the status of your car loan?",
        type: QUESTION_TYPES.RADIO,
        key: QUESTION_KEYS.LOAN,
        options: [
            {
                displayText: "Loan closed",
                key: "CLOSED"
            },
            {
                displayText: "Loan pending",
                key: "PENDING"
            }
        ]
    },
    {
        title: "",
        key: QUESTION_KEYS.CONSENT,
        ctaLabel: "GIVE CONSENT",
        gaEvent: diyLoanCreditReportViewed
    },
    {
        title: "",
        type: QUESTION_TYPES.INPUT,
        key: QUESTION_KEYS.CIBIL,
        subTitle: "This will not impact your credit score at any instant",
        ctaLabel: "CONFIRM",
        gaEvent: diyLoanCreditMobileErrorViewed
    }
];

export const CONSENT_LIST = [
    "Speeds-up deal closure",
    "100% data privacy",
    "Zero impact on your credit score",
    "Reduces loan documents"
];

export const CIBIL_CASES = [QUESTION_KEYS.CIBIL, QUESTION_KEYS.CONSENT];

export const INITIAL_ANSWER_STATE = {
    [QUESTION_KEYS.OWNERSHIP]: "",
    [QUESTION_KEYS.LOAN]: "",
    [QUESTION_KEYS.CONSENT]: true
};
